import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import predictGif from "./assets/GIF-pred.gif"; // 你可以改路径

const MaterialsTable = () => {
    const [materials, setMaterials] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchColumn, setSearchColumn] = useState("formula");

    // 范围搜索输入
    const [minBandGap, setMinBandGap] = useState("");
    const [maxBandGap, setMaxBandGap] = useState("");
    const [minYoung_Modulus, setminYoung_Modulus] = useState("");
    const [maxYoung_Modulus, setMaxYoung_Modulus] = useState("");
    const [minPoissonRatio, setMinPoissonRatio] = useState("");
    const [maxPoissonRatio, setMaxPoissonRatio] = useState("");
    // 清理掉了没用到的冗余 state (比如 rangeColumn, stability)

    const fetchData = () => {
        const hasKeywordSearch = searchTerm && searchColumn;
        const hasRangeSearch =
            minPoissonRatio || maxPoissonRatio ||
            minYoung_Modulus || maxYoung_Modulus ||
            minBandGap || maxBandGap;
        const isBooleanSearch = searchColumn === "Stability" && (searchTerm === "true" || searchTerm === "false");

        // 默认接口
        let endpoint = "/api/materials_summary";

        // 🌟 必杀技 1：强行加入时间戳，彻底粉碎阿里云 CDN 和浏览器缓存！
        let queryParams = `?page=${page}&_t=${new Date().getTime()}`;

        // 如果有任何搜索条件，切换为 search 接口
        if (hasKeywordSearch || hasRangeSearch || isBooleanSearch) {
            endpoint = "/api/materials_summary_search";

            // 1. 布尔搜索 & 常规关键词搜索
            if (isBooleanSearch) {
                queryParams += `&search_column=Stability&search_term=${searchTerm}`;
            } else if (searchTerm && searchColumn && searchColumn !== "Stability") {
                queryParams += `&search_column=${encodeURIComponent(searchColumn)}&search_term=${encodeURIComponent(searchTerm)}`;
            }

            // 🌟 2. 优化后的范围搜索逻辑 (避免拼接出重复的 search_column)
            if (minPoissonRatio || maxPoissonRatio) {
                queryParams += `&search_column=${encodeURIComponent("Poisson's Ratio")}`;
                if (minPoissonRatio) queryParams += `&min=${minPoissonRatio}`;
                if (maxPoissonRatio) queryParams += `&max=${maxPoissonRatio}`;
            } else if (minYoung_Modulus || maxYoung_Modulus) {
                queryParams += `&search_column=${encodeURIComponent("Young's Modulus")}`;
                if (minYoung_Modulus) queryParams += `&min=${minYoung_Modulus}`;
                if (maxYoung_Modulus) queryParams += `&max=${maxYoung_Modulus}`;
            } else if (minBandGap || maxBandGap) {
                queryParams += `&search_column=${encodeURIComponent("Band Gap")}`;
                if (minBandGap) queryParams += `&min=${minBandGap}`;
                if (maxBandGap) queryParams += `&max=${maxBandGap}`;
            }
        }

        const finalUrl = endpoint + queryParams;
        console.log("Final fetch URL:", finalUrl);

        // 🌟 必杀技 2：从本地拿出 Token，塞进请求头，打破重定向死循环！
        const token = localStorage.getItem("token") || "";

        axios.get(finalUrl, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            setMaterials(response.data.materials || []);
            setTotalPages(response.data.total_pages || 1);
        })
        .catch((error) => console.error("Error fetching materials:", error));
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const handleSearch = () => {
        if (page === 1) {
            fetchData();
        } else {
            setPage(1); // 页码变为 1 会自动触发 useEffect 里的 fetchData
        }
    };

    const renderBoolean = (val) => {
        if (val === true) return "True";
        if (val === false) return "False";
        return "N/A";
    };

    return (
        <div className="min-w-full border border-gray-300 shadow-lg">
            <h2 className="table-title">Materials Summary</h2>
            {/* 外层 flex 容器，分成左右两部分 */}
            <div className="flex-container">
                {/* 左边：搜索栏，占 2/3 */}
                <div className="search-container">
                    <select
                        value={searchColumn}
                        onChange={(e) => setSearchColumn(e.target.value)}
                        className="border border-gray-300 px-2 py-1 rounded"
                    >
                        <option value="formula">Formula</option>
                        <option value="reduced_formula">Reduced Formula</option>
                        <option value="crystal_system">Crystal System</option>
                        <option value="space_group_symbol">Space Group</option>
                        <option value="Sites">Sites</option>
                        <option value="_id">ID</option>
                        <option value="Stability">Stability</option>
                    </select>
                    <input
                        type="text"
                        placeholder="Enter search term..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="border border-gray-300 px-2 py-1 rounded w-64"
                    />

                    {searchColumn === "Stability" && (
                    <div className="border border-gray-300 px-2 py-1 rounded">
                        <label>Stability:</label>
                        <select
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="border border-gray-300 px-2 py-1 rounded"
                        >
                            <option value="">--Select--</option>
                            <option value="true">true</option>
                            <option value="false">false</option>
                        </select>
                    </div>
                    )}

               {/* 带隙范围 */}
               <div className="border border-gray-300 px-2 py-1 rounded">
                   <label>Band Gap (eV):</label>
                   <input
                       type="number"
                       value={minBandGap}
                       onChange={(e) => setMinBandGap(e.target.value)}
                       placeholder="Min"
                       className="border border-gray-300 px-2 py-1 rounded"
                   />
                   <span>-</span>
                   <input
                       type="number"
                       value={maxBandGap}
                       onChange={(e) => setMaxBandGap(e.target.value)}
                       placeholder="Max"
                       className="border border-gray-300 px-2 py-1 rounded"
                   />
               </div>

               {/* 杨氏模量范围 */}
               <div className="flex items-center space-x-1">
                   <label>Young's Modulus E (GPa):</label>
                   <input
                       type="number"
                       value={minYoung_Modulus}
                       onChange={(e) => setminYoung_Modulus(e.target.value)}
                       placeholder="Min"
                       className="w-20 px-2 py-1 border rounded"
                   />
                   <span>-</span>
                   <input
                       type="number"
                       value={maxYoung_Modulus}
                       onChange={(e) => setMaxYoung_Modulus(e.target.value)}
                       placeholder="Max"
                       className="border border-gray-300 px-2 py-1 rounded"
                   />
               </div>

               {/* 泊松比范围 */}
               <div className="flex items-center space-x-1">
                   <label>Poisson's Ratio:</label>
                   <input
                       type="number"
                       value={minPoissonRatio}
                       onChange={(e) => setMinPoissonRatio(e.target.value)}
                       placeholder="Min"
                       className="border border-gray-300 px-2 py-1 rounded"
                   />
                   <span>-</span>
                   <input
                       type="number"
                       value={maxPoissonRatio}
                       onChange={(e) => setMaxPoissonRatio(e.target.value)}
                       placeholder="Max"
                       className="border border-gray-300 px-2 py-1 rounded"
                   />
               </div>

               <button
                   onClick={handleSearch}
                   className="flex items-center space-x-1 px-4 py-2 bg-blue-500 text-white rounded"
               >
                   Search
               </button>
           </div>

               {/* 右边：预测卡片，占 1/3 */}
                {/* 右边：工具入口区，占 1/3 */}
           <div className="right-tools">
               {/* Predictor 卡片 */}
               <div className="predict-card">
                   <Link to="/predict" className="predict-link">
                       <h4 className="predict-title">
                           Structure Properties Predictor
                       </h4>
                       <div className="mt-3">
                           <img src={predictGif} alt="Predict CIF" width="340" height="200"/>
                       </div>
                   </Link>
                   <p className="predict-text">
                       Predicting material properties based on structure.
                   </p>
               </div>
               {/* Assistant 卡片 */}
               <div className="assistant-card">
                   <Link to="/assistant" className="assistant-link">
                       <h4 className="assistant-title">
                           Thermodynamics Assistant
                       </h4>
                       <p className="assistant-desc">
                           Ask thermodynamics and materials science questions.</p>
                   </Link>
               </div>
           </div>
           </div>


            {/* 表格展示 */}
            <table className="min-w-full border border-gray-300 shadow-lg">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="px-4 py-2 border">ID_URL</th>
                        <th className="px-4 py-2 border">ID</th>
                        <th className="px-4 py-2 border">Formula</th>
                        <th className="px-4 py-2 border">Reduced Formula</th>
                        <th className="px-4 py-2 border">Crystal System</th>
                        <th className="px-4 py-2 border">Space Group</th>
                        <th className="px-4 py-2 border">Sites</th>
                        <th className="px-4 py-2 border">Stability</th>
                        <th className="px-4 py-2 border">Poisson's Ratio v</th>
                        <th className="px-4 py-2 border">Young's Modulus E (GPa)</th>
                        <th className="px-4 py-2 border">Band Gap (eV)</th>
                    </tr>
                </thead>
                <tbody>
                    {materials.length > 0 ? (
                        materials.map((material) => (
                            <tr key={material._id} className="hover:bg-gray-100">
                                <td className="px-4 py-2 border">
                                    <Link to={`/materials/${material._id}`} className="text-blue-600 hover:underline">
                                        {material._id}
                                    </Link>
                                </td>
                                <td className="px-4 py-2 border">{material._id}</td>
                                <td className="px-4 py-2 border">{material.formula}</td>
                                <td className="px-4 py-2 border">{material.reduced_formula}</td>
                                <td className="px-4 py-2 border">{material.crystal_system}</td>
                                <td className="px-4 py-2 border">{material.space_group_symbol}</td>
                                <td className="px-4 py-2 border">{material.Sites}</td>
                                <td className="px-4 py-2 border">{renderBoolean(material["Stability"])}</td>
                                <td className="px-4 py-2 border">{material["Poisson's Ratio"] ?? "N/A"}</td>
                                <td className="px-4 py-2 border">{material["Young's Modulus E (GPa)"] ?? "N/A"}</td>
                                <td className="px-4 py-2 border">{material["Band Gap (eV)"] ?? "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="9" className="text-center py-4">Loading data...</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* 分页控件 */}
            <div className="page-button-container">
                <button onClick={() => setPage(1)} disabled={page === 1} className="pagination-button">{"«"}</button>
                <button onClick={() => setPage(page - 1)} disabled={page === 1} className="pagination-button">{"<"}</button>
                <span className="page-info"> {page} / {totalPages} </span>
                <button onClick={() => setPage(page + 1)} disabled={page >= totalPages} className="pagination-button">{">"}</button>
                <button onClick={() => setPage(totalPages)} disabled={page >= totalPages} className="pagination-button">{"»"}</button>
            </div>

            {/* CSV 下载按钮 */}
            <div className="table-title">
                <button
                    onClick={() => window.open('/api/download')}
                    className="px-4 py-2 bg-green-500 text-white rounded"
                >
                    Download CSV
                </button>
            </div>
        </div>
    );
};

export default MaterialsTable;
